import { Tab, Tabs } from "react-bootstrap";
import ChangePassword from "../components/account/change_password";
import ChangeEmail from "../components/account/change_email";

const AccountPage = () => {
  return (
    <div className="p-4">
        <h4 className="mb-2 main-title-for-all">Account</h4>
        <p className="gray-text-for-content mb-4">Manage your account settings—update your password for added security and change your email to stay informed.</p>

<div className="bg-white rounded p-4 mb-4" >
      <Tabs defaultActiveKey="password" id="account-tabs" className="mb-3">
        <Tab eventKey="password" title="Change Password">
          <ChangePassword />
        </Tab>
        <Tab eventKey="email" title="Change Email">
          <ChangeEmail />
        </Tab>
      </Tabs>
      </div>
    </div>
  );
};

export default AccountPage;
